import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';

export const sgPieChartAnimations = [
  trigger('fadeInOut', [
    state('in', style({ opacity: 1 })),
    state('out', style({ opacity: 0 })),
    transition('in <=> out', animate('200ms ease-in-out')),
  ]),
  trigger('chartAnimation', [
    state(
      'loading',
      style({
        transform: 'scale(0.95)',
        opacity: 0.7,
      })
    ),
    state(
      'loaded',
      style({
        transform: 'scale(1)',
        opacity: 1,
      })
    ),
    transition('loading => loaded', [
      animate(
        '400ms cubic-bezier(0.4, 0.0, 0.2, 1)',
        keyframes([
          style({ transform: 'scale(0.95)', opacity: 0.7, offset: 0 }),
          style({ transform: 'scale(1.02)', opacity: 0.9, offset: 0.7 }),
          style({ transform: 'scale(1)', opacity: 1, offset: 1 }),
        ])
      ),
    ]),
  ]),
];
